import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('dailyPostingReport', [booksMenu])
  .controller('dailyPostingController', dailyPostingController)
  .name;
  
/* @ngInject */ function dailyPostingController($scope, BooksSvc, SERVER, BusyScreen, Session) {
  $scope.data = {};
  $scope.reportPage = Session.getSessionURL('/PostingReport.aspx');

  /*------------------------------------------------*/
  /* Sets the default report format to PDF and the  */
  /* sorting of the report to be set to sortByTaxID */
  /*------------------------------------------------*/
  $scope.req = { reportFormat: 'PDF' };

  /*-----------------------------------------------*/
  /* Works with the CSMValidator and checks to     */
  /* make sure that the start date and end date    */
  /* fields are populated and formatted correctly. */
  /*-----------------------------------------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    return $scope.valOption.validate();
  };

  /*-----------------------------------------------------------*/
  /* Watches the data.recoreder model and sets the req.loginID */
  /* to the recorder.id or 0 and the req.loginName to the      */
  /* recorder.fullName or to an empty string                   */
  /*-----------------------------------------------------------*/
  $scope.$watch('data.recorder', function (recorder) {
    if (angular.isObject(recorder)) {
      $scope.req.loginID = recorder ? recorder.id : 0;
      $scope.req.loginName = recorder ? recorder.fullName : '';
    }
  });

  /*--------------*/
  /* Get services */
  /*--------------*/
  BooksSvc.getTransactionUserList(SERVER.BooksDBConstants.LET_RECEIPT).then(
    function (resp) {
      $scope.users = resp.data;

      /*-------------------------------------------------------*/
      /* Creates an array of user names formatted as lastName, */
      /* firstName for use in the Recorded By typeahead.       */
      /*-------------------------------------------------------*/
      for (var i = 0; i < $scope.users.length; i++)
        $scope.users[i].fullName = [
          $scope.users[i].lastName,
          $scope.users[i].firstName
        ].join(', ');

      BooksSvc.getOrganization().then(function (resp) {
        $scope.org = resp.data;
        BusyScreen.setBusy(false);
      });
    }
  );
}